import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, SettingsIcon, LayersIcon, ArrowRightIcon, ArrowLeftIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function FPGAAdvantageSlide() {
  return <SlideLayout data-id="element-106" data-mp="wzguugtfl78w">
      <motion.div variants={itemVariants} className="mb-16 text-center" data-id="element-107" data-mp="10yzfdbhcbgb7">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-text mb-4" data-id="element-108" data-mp="11126jyu8bfhi">
          FPGAs: The Sweet Spot
        </h2>
        <p className="text-xl text-brand-text-dim" data-id="element-109" data-mp="1tnn6voson1x7">Between ASICs and GPUs</p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-110" data-mp="1fw8eircvxodh">
        {/* ASIC */}
        <motion.div variants={itemVariants} className="bg-brand-bg-card/50 border border-brand-border rounded-2xl p-8 flex flex-col" data-id="element-111" data-mp="1fuffny8ik8g1">
          <ZapIcon className="w-10 h-10 text-brand-text-muted mb-6" data-id="element-112" data-mp="27mmo4bdv8ejc" />
          <h3 className="text-2xl font-bold text-brand-text mb-4" data-id="element-113" data-mp="2ceeeakt40i8y">ASIC</h3>
          <p className="text-brand-text-muted text-sm mb-6 font-mono" data-id="element-114" data-mp="311xjnlrxus5">
            Google TPU, Groq LPU
          </p>
          <ul className="space-y-4 text-brand-text-dim flex-1" data-id="element-115" data-mp="3u7v65ciwcw6p">
            <li className="flex items-start gap-2" data-id="element-116" data-mp="3u5if89v5vbhi">
              <span className="text-green-500 mt-1" data-id="element-117" data-mp="crwsrhh004pq">•</span> Blazing fast
              performance
            </li>
            <li className="flex items-start gap-2" data-id="element-118" data-mp="7yk79g7m8e17">
              <span className="text-red-500 mt-1" data-id="element-119" data-mp="lr9vlram9v1h">•</span> Circuits frozen at
              fabrication
            </li>
            <li className="flex items-start gap-2" data-id="element-120" data-mp="hqpvceuqybb4">
              <span className="text-red-500 mt-1" data-id="element-121" data-mp="hs146t31u993">•</span> Millions of dollars
              to reprogram
            </li>
            <li className="flex items-start gap-2" data-id="element-122" data-mp="qqw6hu2z2z74">
              <span className="text-red-500 mt-1" data-id="element-123" data-mp="qr5x9jvudadv">•</span> Months of lead time
            </li>
          </ul>
        </motion.div>

        {/* FPGA */}
        <motion.div variants={itemVariants} className="bg-brand-bg-card border-2 border-brand-teal rounded-2xl p-8 flex flex-col relative shadow-[0_0_30px_rgba(0,212,170,0.15)] transform md:-translate-y-4" data-id="element-124" data-mp="2si9b0i11352n">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-1 bg-brand-teal rounded-b-full shadow-[0_0_10px_rgba(0,212,170,0.5)]" data-id="element-125" data-mp="11eqyrhdb4f42" />
          <SettingsIcon className="w-10 h-10 text-brand-teal mb-6" data-id="element-126" data-mp="1aemd1v25sq8b" />
          <h3 className="text-2xl font-bold text-brand-text mb-4" data-id="element-127" data-mp="1afxgftrozvyw">FPGA</h3>
          <p className="text-brand-teal text-sm mb-6 font-mono" data-id="element-128" data-mp="1fcnt074ag9fk">Isochron</p>
          <ul className="space-y-4 text-brand-text flex-1" data-id="element-129" data-mp="1kca7ejvurvpy">
            <li className="flex items-start gap-2" data-id="element-130" data-mp="1kapd8vdgaesm">
              <span className="text-brand-teal mt-1" data-id="element-131" data-mp="1p4l99sa5lrl5">•</span> ~90% of ASIC
              performance
            </li>
            <li className="flex items-start gap-2" data-id="element-132" data-mp="1t3u4z2or7zjc">
              <span className="text-brand-teal mt-1" data-id="element-133" data-mp="1y4goq9aqs8qz">•</span> Fully
              reprogrammable hardware
            </li>
            <li className="flex items-start gap-2" data-id="element-134" data-mp="232i9cyntgg4k">
              <span className="text-brand-teal mt-1" data-id="element-135" data-mp="23171amnc8m7n">•</span> Gates reconfigure
              to the workload
            </li>
            <li className="flex items-start gap-2" data-id="element-136" data-mp="288exfb00tr83">
              <span className="text-brand-teal mt-1" data-id="element-137" data-mp="286kfm5k1qf88">•</span> No silicon respin,
              zero NRE
            </li>
          </ul>
        </motion.div>

        {/* GPU */}
        <motion.div variants={itemVariants} className="bg-brand-bg-card/50 border border-brand-border rounded-2xl p-8 flex flex-col" data-id="element-138" data-mp="1z8ii3zziu4pp">
          <LayersIcon className="w-10 h-10 text-brand-text-muted mb-6" data-id="element-139" data-mp="2qyn0jt3q0hoa" />
          <h3 className="text-2xl font-bold text-brand-text mb-4" data-id="element-140" data-mp="2r0pwsuvgv71g">GPU</h3>
          <p className="text-brand-text-muted text-sm mb-6 font-mono" data-id="element-141" data-mp="2m6lni4yqamx7">
            NVIDIA H100, A100
          </p>
          <ul className="space-y-4 text-brand-text-dim flex-1" data-id="element-142" data-mp="2i62uw8p0hcty">
            <li className="flex items-start gap-2" data-id="element-143" data-mp="3eohcm8g7u27h">
              <span className="text-green-500 mt-1" data-id="element-144" data-mp="3eq257siyzb2p">•</span> Flexible &
              general-purpose
            </li>
            <li className="flex items-start gap-2" data-id="element-145" data-mp="2ufr5ulrful64">
              <span className="text-red-500 mt-1" data-id="element-146" data-mp="2udwlp9nzqx33">•</span> Wasted silicon on
              unused features
            </li>
            <li className="flex items-start gap-2" data-id="element-147" data-mp="2zcho9fqptsup">
              <span className="text-red-500 mt-1" data-id="element-148" data-mp="2lfuoz6baiqlm">•</span> Non-deterministic
              scheduling
            </li>
            <li className="flex items-start gap-2" data-id="element-149" data-mp="2pgwprrkuvapp">
              <span className="text-red-500 mt-1" data-id="element-150" data-mp="3d68xso4g5cqf">•</span> High power draw
            </li>
          </ul>
        </motion.div>
      </div>

      {/* Spectrum Bar */}
      <motion.div variants={itemVariants} className="max-w-4xl mx-auto" data-id="element-151" data-mp="3i4ahnb9p5g2y">
        <div className="flex items-center justify-between text-sm font-mono text-brand-text-muted mb-2 px-4" data-id="element-152" data-mp="34cvtyr4ugqpk">
          <span className="flex items-center gap-2" data-id="element-153" data-mp="38dpk7r5rehlm">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-154" data-mp="3w4bf0gqr65do" /> Speed
          </span>
          <span data-id="element-155" data-mp="3w30cek91n3o5">
            Flexibility <ArrowRightIcon className="w-4 h-4 inline" data-id="element-156" data-mp="4qp79wv5u8f2" />
          </span>
        </div>
        <div className="h-2 bg-brand-border rounded-full relative overflow-hidden flex" data-id="element-157" data-mp="1pgb2yttx5ovy">
          <div className="flex-1 bg-gradient-to-r from-brand-text-muted to-brand-teal/50" data-id="element-158" data-mp="1khhoay2wbru7" />
          <div className="flex-1 bg-brand-teal" data-id="element-159" data-mp="1kfncc99lra29" />
          <div className="flex-1 bg-gradient-to-r from-brand-teal/50 to-brand-text-muted" data-id="element-160" data-mp="1z5cikiwjy49e" />
        </div>
        <div className="flex justify-between text-xs font-bold text-brand-text mt-4 px-8" data-id="element-161" data-mp="1u8m23ugu56ng">
          <span className="w-1/3 text-left" data-id="element-162" data-mp="16irp9cwini37">ASIC</span>
          <span className="w-1/3 text-center text-brand-teal text-base" data-id="element-163" data-mp="11in8dlrp4lcg">
            FPGA
          </span>
          <span className="w-1/3 text-right" data-id="element-164" data-mp="1gfwclg23ljll">GPU</span>
        </div>
      </motion.div>
    </SlideLayout>;
}